import { Pipe, PipeTransform } from '@angular/core';

type PseudoCheckboxState = 'checked' | 'unchecked';

@Pipe({
	name: 'multiSelectorOptionState',
	standalone: true,
})
export class MultiSelectorOptionStatePipe implements PipeTransform {
	transform(option: unknown, selectedItems: unknown[] | null | undefined, bindValue?: string): PseudoCheckboxState {
		const optionValue = this.getBindValue(option, bindValue);
		return (selectedItems ?? []).includes(optionValue) ? 'checked' : 'unchecked';
	}

	private getBindValue(option: unknown, bindValue?: string): unknown {
		if (option && typeof option === 'object' && bindValue) {
			return (option as Record<string, unknown>)[bindValue];
		}
		return option;
	}
}

